module.exports = __webpack_public_path__ + "img/_bookmark.e9a87390.svg";